import React from 'react';

import { Constants } from '../../../../common/Constants';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { DisclaimerContent } from '../../../../common/DisclaimerContent';
import {
  isCnsMember,
  isMnrMember,
} from '../../../../common/Utils/memberUtils/memberUtils';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { getCurrentMember } from '../../../../utils/user.utils';
import { HealthGradesContainerStyled } from '../PSXHome/HealthGradesContainer.styled';
import { ToolTipDisclaimer } from './ToolTipDisclaimer';

type Props = {
  sectionType: string;
  isVisionCare: boolean;
};

export const ViewAllDisclaimers = ({ sectionType, isVisionCare }: Props) => {
  const { lineOfBusiness } = getCurrentMember();
  const isMNR = isMnrMember(lineOfBusiness);
  const isCNS = isCnsMember(lineOfBusiness);

  const [enableMapViewHideOption] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_MAP_VIEW_HIDE_OPTION,
  ]);

  if (isMNR) {
    return (
      <React.Fragment>
        <ToolTipDisclaimer />
        {sectionType !== Constants.RESULT_SECTION.PROVIDER_GROUPS && (
          <HealthGradesContainerStyled
            css={{
              borderTop: enableMapViewHideOption && '0',
            }}
          >
            <DisclaimerContent isViewAllDisclaimer />
          </HealthGradesContainerStyled>
        )}
      </React.Fragment>
    );
  } else if (isCNS) {
    return (
      <React.Fragment>
        <ToolTipDisclaimer />
        <DisclaimerContent />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <ToolTipDisclaimer />
        {sectionType !== Constants.RESULT_SECTION.FACILITY &&
          sectionType !== Constants.RESULT_SECTION.PROVIDER_GROUPS && (
            <HealthGradesContainerStyled
              css={{
                borderTop: enableMapViewHideOption && '0',
              }}
            >
              <DisclaimerContent isVisionCare={isVisionCare} />
            </HealthGradesContainerStyled>
          )}
        {isVisionCare &&
        (sectionType === Constants.RESULT_SECTION.FACILITY ||
          sectionType === Constants.RESULT_SECTION.PROVIDER_GROUPS) ? (
          <HealthGradesContainerStyled
            css={{
              borderTop: enableMapViewHideOption && '0',
            }}
          >
            <DisclaimerContent isVisionCare={isVisionCare} />
          </HealthGradesContainerStyled>
        ) : null}
      </React.Fragment>
    );
  }
};
